import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { BillingFormData } from './billing-form.data';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingFormModalService extends BaseModalService<BillingFormData> {
    readonly submitStatus$ = new Subject<boolean>();
    emitSubmitStatus(status: boolean) {
        this.submitStatus$.next(status);
    }
}
